import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/ContactModal.css'; // Reuse the same styling

const ApplicationModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const [files, setFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    
    // Filter for allowed file types
    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    const validFiles = selectedFiles.filter(file => allowedTypes.includes(file.type));
    
    if (validFiles.length !== selectedFiles.length) {
      alert('Only PDF, DOC, and DOCX files are allowed.');
    }
    
    setFiles(validFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (files.length === 0) {
      alert('Please upload at least one document.');
      return;
    }
    
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Create FormData object for file upload
    const formDataForUpload = new FormData();
    formDataForUpload.append('name', formData.name);
    formDataForUpload.append('email', formData.email);
    formDataForUpload.append('phone', formData.phone);
    files.forEach(file => {
      formDataForUpload.append('files', file);
    });
    formDataForUpload.append('from', 'contact@washuttle.com');
    formDataForUpload.append('to', 'skyharborshuttle@gmail.com,leo.j.white@gmail.com');
    formDataForUpload.append('subject', 'New Applicant Documents');

    try {
      // API Gateway endpoint for application uploads
      const response = await fetch('https://p7thl38pgj.execute-api.us-west-2.amazonaws.com/prod/application-upload', {
        method: 'POST',
        body: formDataForUpload
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
        });
        setFiles([]);
        setTimeout(() => {
          onClose();
          setSubmitStatus(null);
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="modal-content"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={e => e.stopPropagation()}
          >
            <button className="modal-close" onClick={onClose}>×</button>
            <h2>Submit Application</h2>
            <p className="modal-subtitle">Upload your resume and application documents</p>
            
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Full Name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="(123) 456-7890"
                />
              </div>

              <div className="form-group">
                <label htmlFor="documents">Upload Documents *</label>
                <input
                  type="file"
                  id="documents"
                  name="documents"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  multiple
                  className="file-input"
                />
                <small className="file-help">Accepted file types: PDF, DOC, DOCX. At least one document is required.</small>
                {files.length > 0 && (
                  <div className="file-list">
                    <p>Selected files:</p>
                    <ul>
                      {files.map((file, index) => (
                        <li key={index}>{file.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <button
                type="submit"
                className={`submit-button ${isSubmitting ? 'submitting' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Uploading...' : 'Submit Application'}
              </button>

              {submitStatus === 'success' && (
                <div className="status-message success">
                  Application submitted successfully!
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="status-message error">
                  Failed to submit application. Please try again.
                </div>
              )}
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ApplicationModal; 